import { useState, useEffect } from "react";
import { MarketingStockTypesEnum } from "../../../common/constants";
import {useCartContext} from "../../../Context/CartContext";
import style from './MarketingStockCalculator.module.css'

export const MarketingStockCalculator = ({stockId = null, stockTypeId = null}) => {

    const {cart, getCart} = useCartContext();
    const [currentStockModel, setCurrentStockModel] = useState(null);
    const [calculatorModel, setCalculatorModel] = useState({
        StockProductsSum:0,
        DefaultProductsSum:0,
        NeedToBuy: 0,
        IsConditionFulfilled: false
    });

    useEffect(() => {
        const cart = JSON.parse(getCart());

        const currentStockModel = cart.Stocks.find(object => object.Id === stockId);

        if(currentStockModel)
        {
            setCurrentStockModel(currentStockModel);
            setCalculatorModel(currentStockModel.CalculatorModel) 
        }


    }, [cart])

    return (

        <div className={style.pageWrapper}>
            {stockTypeId === MarketingStockTypesEnum.calculating || currentStockModel?.MarketingStockTypeId === MarketingStockTypesEnum.calculating ?
                <div className={style.wrapper}>
                    <div className={`${style.calcBlock} ${style.stockProductsSum}`}>
                        <span>Акційний товар, Σ = {calculatorModel.StockProductsSum.toLocaleString('uk-UA', {
                                    style: 'currency', currency: 'UAH', currencyDisplay: 'symbol'
                                })}</span>
                    </div>
                    <div className={`${style.calcBlock} ${style.defaultProductsSum}`}>
                        <span>Товар по базовій ціні, Σ = {calculatorModel.DefaultProductsSum.toLocaleString('uk-UA', {
                                    style: 'currency', currency: 'UAH', currencyDisplay: 'symbol'
                                })}</span>
                    </div>
                    <div className={`${style.calcBlock} ${calculatorModel.IsConditionFulfilled ? style.needToBuyFulfilled : style.needToBuy}`}>
                        {!calculatorModel.IsConditionFulfilled ? <span>Необхідно дозамовити на {calculatorModel.NeedToBuy.toLocaleString('uk-UA', {
                                    style: 'currency', currency: 'UAH', currencyDisplay: 'symbol'
                                })}</span>: <span>Умову акції виконано :)</span> }
                    </div>
            </div> : null
            }
        </div>
    )
}